import { useParams } from 'react-router';

import { CatalogCategoryForm } from './CatalogCategoryForm';
import { useCatalogCategoryQuery } from './useCatalogCategoryEditor';
import { defaultCatalogCategoryForm, catalogCategoryToForm } from './catalogFormValues';
import { CatalogEntityHeader } from './CatalogEntityHeader';
import { CatalogRequestState } from './CatalogRequestState';
import './catalogEditor.css';

export function CatalogCategoryEditorPage() {
  const params = useParams();
  
  const routeId = params.categoryId;
  const entityId = routeId === undefined ? undefined : Number(routeId);
  const isValidId = entityId === undefined || (Number.isSafeInteger(entityId) && entityId > 0);
  const query = useCatalogCategoryQuery(isValidId ? entityId : undefined);
  const initialValues = routeId === undefined ? defaultCatalogCategoryForm : query.data ? catalogCategoryToForm(query.data) : undefined;
  const errorMessage = !isValidId ? 'Некорректный адрес страницы.' : query.error?.message;

  return (
    <section className="admin-page catalog-workspace">
      {initialValues && !errorMessage ? (
        <CatalogCategoryForm key={routeId ?? 'new'} initialValues={initialValues} entityId={entityId}  />
      ) : (
        <><CatalogEntityHeader kind="categories" title="Категория" subtitle="Редактирование" /><CatalogRequestState error={errorMessage} onRetry={() => { void query.refetch(); }} /></>
      )}
    </section>
  );
}
